// extracted by mini-css-extract-plugin
export default {"backdrop":"backdrop--o7ACO","root":"root--b7U7F","content":"content--gncwh","icon":"icon--sZcEa","title":"title--q3Q47","description":"description--MaQSu","actions":"actions--TimDY"};